import React from 'react'

const Schemes = () => {
  return (
    <div className="container my-3">

    <div className="abouts">
        <h5>Schemes</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>
<p>The hybrid vegetable seeds of different crops / varieties for Rabi and Kharif seasons are being provided to the farmers on 50% subsidy under RKVY scheme.</p>
<p>
Vegetable assistance on seed production program of open pollinated and hybrid varieties is also being given to the farmers of Haryana under National Horticulture mission scheme as per details given below:</p>
       
<ul style={{listStyleType:'square'}}>
														<li>Rs. 20,000/- per acre for Hybrid Seed Production to be
															organise at Public sector</li>
                                                            <hr></hr>
														<li>Rs. 10,000/- per acre for Conventional varieties s/p to be
															organise at Public sector</li>
                                                            <hr></hr>
														<li>Rs. 5,000/- per acre for Conventional varieties s/p to be
															organise at Private sector</li>
                                                            <hr></hr>
													</ul>
        </div>
    </div>
  )
}

export default Schemes
